import axios from 'axios'
axios.defaults.withCredentials = true
axios.interceptors.request.use(function (config) {
    return config
}, function (error) {
    return Promise.reject(error)
})
axios.interceptors.response.use(function (response) {
    return response
}, function (error) {
    return Promise.reject(error)
})
// 获取意见反馈分类
export async function getFeedbackList() {
    const url = process.env.VUE_APP_API_BASE + `/base/feedback/list/categories`
    let {state,data}  = await axios.get(url)
    return await data
}
// 上传图片
export async function upload(e) {
    const url = process.env.VUE_APP_API_FILECENTER + "/image/upload"
    let {state,data}  =  await axios.post(url, e)
    return await data
}
// 提交意见反馈
export async function submitFeedback(e) {
    const url = process.env.VUE_APP_API_BASE + "/base/feedback/record"
    let {state,data}  =  await axios.post(url, e)
    return await data
}
// 提交意见反馈
export async function accountTest() {
    const url = process.env.VUE_APP_API_FOCUS + "/account/test"
    let {state,data}  = await axios.get(url)
    return await data
}
export async function closeAccount() {
    const url = process.env.VUE_APP_API_FOCUS + "/closeaccount/execute"
    let {state,data}  = await axios.post(url)
    return await data
  };
// 获取会员商品信息
export function getShop (shopName) {
    const url = process.env.VUE_APP_API_BASE + '/goods/shop/' + shopName
    return axios.get(url).then((res) => {
        return Promise.resolve(res.data)
    })
}
// 获取用户会员信息
export function getVipInfo () {
    const url = process.env.VUE_APP_API_FOCUS + '/vip/info'
    return axios.get(url).then((res) => {
        return Promise.resolve(res.data)
    })
}
// 下订单
export function postMember (res) {
    const url = process.env.VUE_APP_API_BASE + '/goods/order/preorder'
    return axios.post(url, res).then((res) => {
      return Promise.resolve(res.data)
    })
}
// 获取种子总数
export function getSeeds () {
    const url = process.env.VUE_APP_API_FOCUS + '/seed/amount'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
}
export function getSeedRecord () {
    const url = process.env.VUE_APP_API_FOCUS + '/seed/record'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
}